<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <pack-form
    v-else
    :initPack="initPack"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Pack from '@/models/inventory/Pack'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import PackForm from '@/views/inventory/packs/PackForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute } from 'vue-router'
import {router} from "@/router";

export default defineComponent({
  name: 'pack',
  components: {
    LoadingSpinner,
    PackForm,
    AlertBadge
  },

  setup() {
    const initPack = ref(new Pack())
    const http = useHTTP()
    const loading = ref(true)
    const error = ref({ title: '', body: '' })

    const route = useRoute()

    onBeforeMount(async () => {
      const url = `${Pack.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Pack>(url)
        initPack.value = Pack.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (pack: Pack) => {
      try {
        const url = `${Pack.ENDPOINT}/${pack.id}`
        const resp = await http.put<Pack>(url, pack)
        initPack.value = Pack.from(resp)
        router.back()
      } catch (error) {
        return error
      }
    }

    return {
      initPack,
      loading,
      update,
      error
    }
  }
})
</script>
